import { setGetListCurrency } from './setGetListCurrency';
import { putCurrency } from '../api/putCurrency';

export const setPutCurrency = (params) => {
    return async (dispatch, getState) => {
        try {
            await putCurrency(params);
            dispatch(setGetListCurrency());
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}